import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import { Link } from 'react-router-dom';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginBottom: '1rem'
  },
  container: {
    maxHeight: 440
  }
});

const TableGeneralStudentReport = ({
  title,
  columns,
  rows,
  pagination,
  tourSelector,
  periodoId
}) => {
  const { resetStateFilters } = useContext(FilterRelatorioContext);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [statusParam, setStatusParam] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [orderBy, setOrderBy] = useState(columns[0].id);
  const [order, setOrder] = useState('desc');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event, property) => {
    const columnFilter = columns.filter(
      (column) => column.id === 'porc_acertos'
    );
    let isAsc = orderBy === property && order === 'asc';
    if (property === 'status' && columnFilter) {
      isAsc = order === 'asc';
      setOrderBy('porc_acertos');
      setOrder(isAsc ? 'desc' : 'asc');
    } else {
      setOrderBy(property);
      setOrder(isAsc ? 'desc' : 'asc');
    }
  };

  const descendingComparator = (a, b, orderBy) => {
    let valueA = a[orderBy];
    let valueB = b[orderBy];

    if (orderBy === 'porc_acertos') {
      valueA = Number(a[orderBy].replace('%', ''));
      valueB = Number(b[orderBy].replace('%', ''));
    }

    if (valueB < valueA) {
      return -1;
    }
    if (valueB > valueA) {
      return 1;
    }
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  const handleInputChange = (value) => {
    if (value) {
      rows.map((row) =>
        row.porc_acertos &&
          Number(row.porc_acertos.replace('%', '')) >= Number(value)
          ? (row.status = 1)
          : (row.status = 0)
      );
      setStatusParam(value);
    }
  };

  return (
    <>
      {title ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Quicksand'
          }}
        >
          <h1>{title}</h1>
        </div>
      ) : (
        ''
      )}
      <div style={{ padding: '1rem' }}>
        Porcentagem mínima para domínio da habilidade (%) :
        <input
          style={{
            marginLeft: '3px',
            borderRadius: '2px',
            borderColor: '#ccc'
          }}
          type="number"
          value={statusParam}
          min="0"
          onChange={(e) => {
            handleInputChange(e.target.value);
          }}
        />
      </div>
      <Paper className={classes.root} data-tut={tourSelector}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size={'small'}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={createSortHandler(column.id)}
                    >
                      {column.label}
                      {orderBy === column.id ? (
                        <span className={classes.visuallyHidden} />
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows ? (
                stableSort(rows, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.id != 'status' ? (
                                column.format && typeof value === 'number' ? (
                                  column.format(value)
                                ) : (
                                  <>
                                    {column.id == 'idn' ? (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: column.align,
                                          marginLeft: '1rem',
                                          textDecoration: 'none',
                                          color: 'black'
                                        }}                                        
                                        onClick={() => { 
                                          resetStateFilters();
                                          window.open(`/filter-aluno?idn=${value}&periodoAno=${periodoId}`);
                                         }}
                                      >
                                        <i
                                          className="fas fa-eye"
                                          style={{ fontSize: '1.5rem' }}
                                        />
                                      </div>
                                    ) : (
                                      value
                                    )}
                                  </>
                                )
                              ) : value ? (
                                <ThumbUpIcon
                                  style={{
                                    color: '#5cc73c'
                                  }}
                                />
                              ) : (
                                <ThumbDownIcon
                                  style={{
                                    color: '#c73c3c'
                                  }}
                                />
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow align="center">
                  <label
                    style={{ margin: '1rem', color: 'black', fontSize: '16px' }}
                  >
                    Nenhum dado encontrado
                  </label>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {pagination ? (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : (
          ''
        )}
      </Paper>
    </>
  );
};

TableGeneralStudentReport.propTypes = {
  pagination: PropTypes.bool
};

TableGeneralStudentReport.defautProps = {
  pagination: true
};

export default TableGeneralStudentReport;
